import React from 'react'

import {OptimizerStockLevelsCardMaterialDetailHeader} from './detail/OptimizerStockLevelsCardMaterialDetailHeader'
import {useSelectedMaterialId} from './SelectedMaterialIdProvider'
import {OptimizerStockLevelsCardSummaryHeader} from './summary/OptimizerStockLevelsCardSummaryHeader'

type OptimizerStockLevelsCardHeaderProps = {
  isCollapsed: boolean
}

export const OptimizerStockLevelsCardHeader: React.FC<OptimizerStockLevelsCardHeaderProps> = ({
  isCollapsed
}) => {
  const {materialId} = useSelectedMaterialId()
  if (materialId !== undefined) {
    return <OptimizerStockLevelsCardMaterialDetailHeader isCollapsed={isCollapsed} />
  }
  return <OptimizerStockLevelsCardSummaryHeader isCollapsed={isCollapsed} />
}
